import template from './referralKiwiSelectError.html';
import './style.scss';

export default {
  template,
  bindings: {
    fatalErrorsData: '<',
  },
};
